import axios from "axios";

import Config from "../../config";

const actionListaWebhooks = clienteId => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/integracoes/webhooks/lista/${clienteId}`
    });
};

export default actionListaWebhooks;
